import React from "react";
import { Button } from "subframe/components/Button";
import { useNavigate } from "react-router-dom";
import { getEmployeeProfileRoute } from "modules/Retention/constants/routes";
import useUser from "hooks/userHooks";

interface FollowUpActionsProps {
  onLogFollowUp: () => void;
  onLearnMore: () => void;
  onForwardEscalation: () => void;
  onSetReminder: () => void;
  isLoading?: boolean;
  employeeId?: number;
}

const FollowUpActionsSkeleton: React.FC = () => (
  <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
    <div className="h-10 w-32 bg-neutral-200 rounded animate-pulse" />
    <div className="h-10 w-40 bg-neutral-200 rounded animate-pulse" />
    <div className="h-10 w-36 bg-neutral-200 rounded animate-pulse" />
  </div>
);

export const FollowUpActions: React.FC<FollowUpActionsProps> = ({
  onLogFollowUp,
  onLearnMore,
  onForwardEscalation,
  onSetReminder,
  isLoading = false,
  employeeId,
}) => {
  const navigate = useNavigate();
  const { user } = useUser();

  const handleLearnMore = () => {
    if (employeeId) {
      // Navigate to employee profile page
      const profileRoute = getEmployeeProfileRoute(user?.agency_id);
      navigate(profileRoute.replace(":id", employeeId.toString()));
    } else {
      // Fallback to the original onLearnMore function
      onLearnMore();
    }
  };

  if (isLoading) {
    return <FollowUpActionsSkeleton />;
  }

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
      <Button icon="FeatherUserCheck" onClick={onLogFollowUp}>
        Log Follow-up
      </Button>
      <Button
        variant="brand-secondary"
        icon="FeatherUserCircle"
        onClick={handleLearnMore}
      >
        Learn more about employee
      </Button>
      <Button
        variant="brand-secondary"
        icon="FeatherClock"
        onClick={onSetReminder}
      >
        Set reminder
      </Button>
      <Button
        variant="brand-secondary"
        icon="FeatherSend"
        onClick={onForwardEscalation}
      >
        Forward escalation
      </Button>
    </div>
  );
}; 